import { NovaModalDialog } from '#components'
import { ROUTES } from '@configs'
import { FacilityRentalAvailableStatus } from '@store'

interface UseFacilityNextStep {
  onStart?: () => void
  onEnd?: () => void
  onError?: (err: any) => void
  onNextStep: () => any
  facilityCode?: string
}

export const useFacilityNextStep = async ({
  onStart,
  onEnd,
  onError,
  onNextStep,
  facilityCode,
}: UseFacilityNextStep) => {
  const userStore = useUserStore()
  const { certifiedKYC } = useKyc()
  const { kycStatus } = storeToRefs(userStore)
  const facilityStore = useFacilityStore()
  const { rentAvailableStatus } = storeToRefs(facilityStore)
  const { show: modalShow, hide: modalHide } = useModal()
  const { showSignInDialog } = useMembershipProcess()

  try {
    onStart?.()
    switch (rentAvailableStatus.value) {
      case FacilityRentalAvailableStatus.UNAVAILABLE_REQUIRE_SIGN_IN:
        await showSignInDialog()
        break
      case FacilityRentalAvailableStatus.UNAVAILABLE_REQUIRE_KYC_AUTH:
        await userStore.fetchKycStatus()
        if (kycStatus.value?.kycAt === 'N') {
          await modalShow({
            component: NovaModalDialog,
            bind: {
              name: modalsName.MODAL_DIALOG,
              contentsTextAlign: 'center',
              btns: [
                {
                  label: '닫기',
                  theme: 'secondary-gray',
                  size: 32,
                  onClick: async () => {
                    await modalHide(modalsName.MODAL_DIALOG)
                  },
                },
                {
                  label: 'KYC 인증하러 가기',
                  theme: 'primary-blue-dark',
                  size: 32,
                  onClick: async () => {
                    await modalHide(modalsName.MODAL_DIALOG)
                    await certifiedKYC('reward')
                  },
                },
              ],
            },
            slots: {
              title: '알림',
              content:
                'KYC 인증을 완료하셔야  <br/>The Moon Ent. 입주신청서 작성이 가능합니다.',
            },
          })
        }
        break
      case FacilityRentalAvailableStatus.UNAVAILABLE_APPLIED_LESS_THAN_20_DAYS:
        await useNavigations({
          url: useRoutePathIdChange(ROUTES.APPLY_RENT_FACILITY_COMPLETE.path, {
            id: String(facilityCode),
          }),
        })
        break
      case FacilityRentalAvailableStatus.UNAVAILABLE_APPLIED_LESS_THAN_60_DAYS:
        await modalShow({
          component: NovaModalDialog,
          bind: {
            name: modalsName.MODAL_DIALOG,
            btns: [
              {
                label: '확인',
                theme: 'primary-blue-dark',
                size: 32,
                onClick: async () => {
                  await modalHide(modalsName.MODAL_DIALOG)
                },
              },
            ],
          },
          slots: {
            title: '알림',
            content:
              '입주 재신청은 지난 신청일 기준 <br/>60일 이후부터 가능합니다.',
          },
        })
        break
      case FacilityRentalAvailableStatus.AVAILABLE_WITH_APPLY_CREATOR:
      case FacilityRentalAvailableStatus.AVAILABLE_WITH_ALREADY_CREATOR:
        onNextStep()
        break
      case FacilityRentalAvailableStatus.UNAVAILABLE_REQUIRE_CONDITIONS:
      default:
        return Promise.reject(new Error('rent available status is not match'))
    }
  } catch (err) {
    if (onError) {
      onError(err)
      return
    }
    throw showError({
      statusCode: 500,
      statusMessage: 'use facility next step error',
    })
  } finally {
    onEnd?.()
  }
}
